
export default {
  props: {
    size: {
      default: "md"
    }
  }
};
